$(document).ready(function(){
  $(".ing-list span").click(function(){
    var cId = $(this).attr("data-popup");
    $("#" + cId).addClass("popup-enabled")
  })
   $(".close-btn").click(function(){
   $(this).parent(".ingrediant-popup").removeClass("popup-enabled")
  })

$(document).on("click", ".close-btn", function(){
  // Close large ingredient popup
  $(this).closest(".ingrediant-popup").removeClass("popup-enabled");
  
  // Close small popup
  $(this).closest(".small-popup").fadeOut();
});

   $(".tabdes").hide();

  $(".ptab").click(function () {
    var cTab = $(this).attr("data-tab");
    var content = $("#" + cTab);

    // If the clicked tab is already active and visible — hide it and remove active
    if ($(this).hasClass("active") && content.is(":visible")) {
      content.slideUp();
      $(this).removeClass("active");
    } else {
      // Otherwise, hide others, show this one, update active classes
      $(".tabdes").slideUp();
      content.slideDown();
      $(".ptab").removeClass("active");
      $(this).addClass("active");
    }
  });
   $('.full-list-show').click(function(e) {
     var currentfulllist = $(this).attr("data-full-list")
     $("#"+ currentfulllist).addClass("popup-enabled").siblings().removeClass("popup-enabled")
    e.preventDefault(); // prevent the default jump
    var target = $(this).attr('href'); // get the target id
    $('html, body').animate({
      scrollTop: $(target).offset().top
    }, 800); // 800ms for smooth scroll
  });
   $(document).on('click', '.ing', function(e) {
   var csmall = $(this).attr("data-popup");
   console.log("Clicked ingredient:", csmall); // Debug line
   $("#"+csmall).fadeIn().siblings(".small-popup").fadeOut();
});

$(document).on("click", ".swatch-input__label", function(){
    var curvig = $(this).attr("data-anchor");
    $("#tab-" + curvig).show().siblings(".tabdes").hide();
    $(".ig-tab").attr("data-tab", "tab-" + curvig);
     $(".full-list-show").attr("data-full-list", curvig);
});
 var swiper = new Swiper(".igswiper", {
     pagination: {
        el: ".swiper-pagination",
        clickable: true,

      },
    });

  
})

